var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTopbarBack = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1385 2.79015C16.5305 3.17915 16.533 3.81231 16.144 4.20435L8.40874 12L16.144 19.7956C16.533 20.1877 16.5305 20.8209 16.1385 21.2099C15.7464 21.5989 15.1133 21.5964 14.7243 21.2044L6.29015 12.7044C5.90328 12.3145 5.90328 11.6855 6.29015 11.2956L14.7243 2.79565C15.1133 2.40361 15.7464 2.40115 16.1385 2.79015Z",
    fill: "#A1A7B2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTopbarBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_topbar_back.e6fc89d2510210bfc1727fb351fb0206.svg";